import { render, staticRenderFns } from "./CompareLearningProgressPanel.vue?vue&type=template&id=0204478e&scoped=true&lang=pug&"
import script from "./CompareLearningProgressPanel.vue?vue&type=script&lang=ts&"
export * from "./CompareLearningProgressPanel.vue?vue&type=script&lang=ts&"
import style0 from "./CompareLearningProgressPanel.vue?vue&type=style&index=0&id=0204478e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204478e",
  null
  
)

export default component.exports